import script from "./WaysToGiveView.vue?vue&type=script&setup=true&lang=js"
export * from "./WaysToGiveView.vue?vue&type=script&setup=true&lang=js"

import "./WaysToGiveView.vue?vue&type=style&index=0&id=2ea35c8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea35c8e"]])

export default __exports__